import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid, ListItem, Button, Paper, Checkbox, ListItemIcon, List, ListItemText, ListItemSecondaryAction, Typography, IconButton } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import LinkIcon from '@material-ui/icons/Link';

import { transferListStyle } from './style/transferListStyle';

/**
 * region for hepers*/
import typing from '../../helpers/typing';


class TransferList extends Component {

    state = {
        searchingField: "",
        selectListRight: [],
        selectListLeft: [],
        currentlyMarked: [],
        errors: false
    };

    componentWillReceiveProps(nextProps) {
        this.setState({ selectListRight: nextProps.selectListRight, selectListLeft: nextProps.selectListLeft, errors: nextProps.errors });
    }

    handleToggle = (item) => () => {
        const exist = this.state.currentlyMarked.some(itemSelect => String(item.ID) === String(itemSelect.ID));
        let newChecked = [...this.state.currentlyMarked];

        if (!exist) {
            newChecked.push(item);
        } else {
            newChecked = newChecked.filter(i => i.ID !== item.ID);
        }

        this.setState({ currentlyMarked: newChecked });
    };

    handleAllRight = () => {
        let newTrasferList = [];
        let oldTrasferList = this.state.selectListRight;
        let toAddTrasferList = [];
        if (typing.isDefined(oldTrasferList)) {
            oldTrasferList.forEach(function (x) {
                newTrasferList.push(x);
            });
        }

        toAddTrasferList = this.state.selectListLeft;
        if (typing.isDefined(toAddTrasferList)) {
            toAddTrasferList.forEach(function (x) {
                if (!newTrasferList.some(d => d.ID === x.ID)) {
                    newTrasferList.push(x);
                }
            });
        }

        this.setState({ currentlyMarked: [], selectListLeft: [], selectListRight: newTrasferList }, function () {
            let errors = (newTrasferList.length > 0) ? false : true;
            this.props.onAttributeUpdate([], newTrasferList, errors);
        });
    };

    handleAllLeft = () => {
        let newTrasferList = [];
        let oldTrasferList = this.state.selectListLeft;
        let toAddTrasferList = [];
        if (typing.isDefined(oldTrasferList)) {
            oldTrasferList.forEach(function (x) {
                newTrasferList.push(x);
            });
        }

        toAddTrasferList = this.state.selectListRight;
        if (typing.isDefined(toAddTrasferList)) {
            toAddTrasferList.forEach(function (x) {
                if (!newTrasferList.some(d => d.ID === x.ID)) {
                    newTrasferList.push(x);
                }
            });
        }

        this.setState({ currentlyMarked: [], selectListLeft: newTrasferList, selectListRight: [] }, function () {
            this.props.onAttributeUpdate(newTrasferList, [], true);
        });
    };

    handleCheckedRight = (e) => {
        let newTrasferList = [];
        let oldTrasferList = this.state.selectListRight;
        let toAddTrasferList = [];
        // let currentlyMarked = [];
        let waitingToMarked = [];
        if (typing.isDefined(oldTrasferList)) {
            oldTrasferList.forEach(function (x) {
                newTrasferList.push(x);
            });
        }
        toAddTrasferList = this.intersection(this.state.currentlyMarked, this.state.selectListLeft);
        waitingToMarked = this.not(this.state.currentlyMarked, this.state.selectListLeft);
        // currentlyMarked = this.not(this.state.currentlyMarked, toAddTrasferList);/*checarcaso*/
        if (typing.isDefined(toAddTrasferList)) {
            toAddTrasferList.forEach(function (x) {
                if (!newTrasferList.some(d => d.ID === x.ID)) {
                    newTrasferList.push(x);
                }
            });
        }
        this.setState({ currentlyMarked: [], selectListRight: newTrasferList, selectListLeft: waitingToMarked }, function () {
            let errors = (newTrasferList.length > 0) ? false : true;
            this.props.onAttributeUpdate(this.state.selectListLeft, this.state.selectListRight, errors);
        });

    };

    handleCheckedLeft = (e) => {
        let newTrasferList = [];
        let oldTrasferList = this.state.selectListLeft;
        let toAddTrasferList = [];
        // let currentlyMarked = [];
        let waitingToMarked = [];
        if (typing.isDefined(oldTrasferList)) {
            oldTrasferList.forEach(function (x) {
                newTrasferList.push(x);
            });
        }
        toAddTrasferList = this.intersection(this.state.currentlyMarked, this.state.selectListRight);
        waitingToMarked = this.not(this.state.currentlyMarked, this.state.selectListRight);
        // currentlyMarked = this.not(this.state.currentlyMarked, toAddTrasferList);/*checarcaso*/
        if (typing.isDefined(toAddTrasferList)) {
            toAddTrasferList.forEach(function (x) {
                if (!newTrasferList.some(d => d.ID === x.ID)) {
                    newTrasferList.push(x);
                }
            });
        }
        this.setState({ currentlyMarked: [], selectListRight: waitingToMarked, selectListLeft: newTrasferList }, function () {
            let errors = (newTrasferList.length > 0) ? false : true;
            this.props.onAttributeUpdate(this.state.selectListLeft, this.state.selectListRight, errors);
        });
    };

    not(a, b) {
        return b.filter(({ ID }) => !a.some(d => d.ID === ID));
    }

    intersection(a, b) {
        return a.filter(({ ID }) => b.some(d => d.ID === ID));
    }

    customList(items) {
        const { classes } = this.props;
        let list;
        list = <Paper className={classes.paper}>
            <List component="div" role="list" dense={true}>
                {items && Object.keys(items).length > 0 && items.map((item, index) => {
                    const labelId = `transfer-list-item-${item.ID}-label`;
                    return (
                        <ListItem key={item.ID} role="listitem" button onClick={this.handleToggle(item)} >
                            <ListItemIcon>
                                <Checkbox
                                    edge="start"
                                    checked={this.state.currentlyMarked.some(itemSelect => String(item.ID) === String(itemSelect.ID)) ? true : false}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{ 'aria-labelledby': labelId }}
                                />
                            </ListItemIcon>
                            <ListItemText id={labelId}>
                                <Typography noWrap>{item.TEXT}</Typography>
                            </ListItemText>
                            {this.props.enableLink && <ListItemSecondaryAction>
                                <IconButton
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={this.props.baseLink + "=" + item.ID}
                                    edge="end"
                                    aria-label="comments">
                                    <LinkIcon />
                                </IconButton>
                            </ListItemSecondaryAction>
                            }
                        </ListItem>
                    );
                })}
                <ListItem />
            </List>
        </Paper>
        return list;
    }

    render() {
        const { classes } = this.props;
        let selectListLeft = this.state.selectListLeft;
        let selectListRight = this.state.selectListRight;

        let countRowsLeft = 1;
        let countRowsRight = 1;
        // let countRowsLeft = this.state.selectListLeft.totalCount;
        // let countRowsRight = this.state.selectListRight.totalCount;

        let left = false;
        if (typing.isDefined(countRowsLeft) === false || countRowsLeft === 0) {
            left = true;
        }

        let right = false;
        if (typing.isDefined(countRowsRight) === false || countRowsRight === 0) {
            right = true;
        }
        let TextError = "Sorry, select at least one";
        return (
            <Grid container spacing={1} justify="center" alignItems="center" className={classes.root}>
                <Grid item xs={12} sm={5}>
                    {this.customList(selectListLeft)}
                </Grid>
                <Grid item xs={12} sm={2}>
                    <Grid container direction="column" alignItems="center">
                        <Button
                            variant="outlined"
                            size="small"
                            className={classes.button}
                            onClick={this.handleAllRight.bind(this)}
                            disabled={left}
                            aria-label="move all right">
                            <Typography>≫</Typography>
                        </Button>
                        <Button
                            variant="outlined"
                            size="small"
                            className={classes.button}
                            onClick={this.handleCheckedRight.bind(this)}
                            //   disabled={leftChecked.length === 0}
                            aria-label="move selected right">
                            <Typography>&gt;</Typography>
                        </Button>
                        <Button
                            variant="outlined"
                            size="small"
                            className={classes.button}
                            onClick={this.handleCheckedLeft.bind(this)}
                            //   disabled={rightChecked.length === 0}
                            aria-label="move selected left">
                            <Typography>&lt;</Typography>
                        </Button>
                        <Button
                            variant="outlined"
                            size="small"
                            className={classes.button}
                            onClick={this.handleAllLeft.bind(this)}
                            disabled={right}
                            aria-label="move all left">
                            <Typography>≪</Typography>
                        </Button>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={5}>
                    {this.customList(selectListRight)}
                </Grid>
                {
                    (this.state.errors === true && this.props.showErrors===true) &&
                    < caption >
                        <Alert severity="error"> {TextError}</Alert>
                    </caption>
                }
            </Grid>
        )
    }
};
TransferList.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(transferListStyle)(TransferList);